var filterDrawer = document.querySelector(".drawer-filter");
var filterDrawerBackdrop = document.querySelector(".drawer-filter__backdrop");
var bodyElem = document.getElementsByTagName("body")[0];
var closeFilterBtn = document.querySelector("#filter-close");
var triggerFilterDrawerBtn = document.querySelector(".toggle-filters");
var sortBySelect = document.getElementById("sort-by");

const form = document.getElementById("filter-form");
const inputs = document.querySelectorAll(
  '[data-component="filter-form"] input'
);
const applyFiltersButton = document.querySelector(
  '[data-component="filter-form"] button[type="submit"]'
);
var clearFiltersDrawer = document.querySelector("#filter-drawer-clear");
var clearActiveFilters = document.querySelector("#filter-active-clear") || null;

function appliedFiltersCount() {
  const btnToggleDrawerCount = document.getElementById("filter-count");
  const url = window.location.href;

  // Extracting the query parameters from the URL
  const params = new URLSearchParams(url.split("?")[1]);

  // Filter and count the parameters that start with "filter."
  const count = Array.from(params.keys()).filter((key) =>
    key.startsWith("filter.")
  ).length;

  // Update submit button
  if (count > 0) {
    applyFiltersButton.disabled = false;
  }

  // Update buttons
  const countText = count >= 1 ? `(${count})` : "";
  btnToggleDrawerCount.innerHTML = countText;

  return count;
}

var filtersApplied = appliedFiltersCount();

function closeFilterDrawer() {
  filterDrawer.classList.add("hidden");
  filterDrawerBackdrop.classList.remove("active");
  bodyElem.classList.remove("no-scroll");
}

function showFilterDrawer() {
  filterDrawer.classList.remove("hidden");
  filterDrawerBackdrop.classList.add("active");
  bodyElem.classList.add("no-scroll");
}

inputs.forEach((input) => {
  input.addEventListener("click", () => {
    const label = input.parentElement.querySelector("label");

    if (input.checked) {
      label.classList.add("active");
    } else {
      label.classList.remove("active");
    }

    const anyInputChecked = Array.from(inputs).some((input) => input.checked);

    // Enable or disable the button based on checked inputs
    applyFiltersButton.disabled = !anyInputChecked;
  });
});

function clearFilters() {
  inputs.forEach((input) => {
    input.checked = false;
    const label = input.parentElement.querySelector("label");
    label.classList.remove("active");
  });

  // Disable the button after clearing all query parameters
  applyFiltersButton.disabled = true;

  // Remove query parameters
  const { origin, pathname } = window.location;
  const sortParam = new URLSearchParams(window.location.search).get("sort_by");
  let url;

  if (sortParam) {
    url = `${origin}${pathname}?sort_by=${sortParam}`;
  } else {
    url = `${origin}${pathname}`;
  }

  // const url = new URL(window.location);
  window.history.pushState({}, "", url);

  location.reload();
}

function buildQueryString(form) {
  const inputs = form.querySelectorAll(
    '[data-component="filter-form"] input, [data-component="filter-form"] select'
  );
  const params = [];

  inputs.forEach((input) => {
    if (input.type === "checkbox" || input.type === "radio") {
      if (input.checked) {
        params.push(
          `${encodeURIComponent(input.name)}=${encodeURIComponent(input.value)}`
        );
      }
    } else {
      params.push(
        `${encodeURIComponent(input.name)}=${encodeURIComponent(input.value)}`
      );
    }
  });

  const sortParam = new URLSearchParams(window.location.search).get("sort_by");
  if (sortParam) {
    params.push(`sort_by=${encodeURIComponent(sortParam)}`);
  }

  return params.join("&");
}

function applyFilters() {
  var filterForm = document.querySelector('[data-component="filter-form"]');
  const queryParams = buildQueryString(filterForm);
  const url = `${window.location.origin}${window.location.pathname}?${queryParams}`;

  window.history.pushState({}, "", url);
  location.reload();
  closeFilterDrawer();
}

applyFiltersButton.addEventListener("click", () => {
  applyFilters();
});

/* Actions */
triggerFilterDrawerBtn.addEventListener("click", function (event) {
  event.preventDefault();
  showFilterDrawer();
});

closeFilterBtn.addEventListener("click", function (event) {
  event.preventDefault();
  closeFilterDrawer();
});

filterDrawerBackdrop.addEventListener("click", function (event) {
  event.preventDefault();
  closeFilterDrawer();
});

clearFiltersDrawer.addEventListener("click", () => {
  clearFilters();
});

if (clearActiveFilters) {
  clearActiveFilters.addEventListener("click", () => {
    clearFilters();
  });
}

/* Sort */
function applySort(value) {
  var url = new URL(window.location.href);

  url.searchParams.set("sort_by", value);

  window.location.href = url.href;
}

sortBySelect.addEventListener("change", function () {
  var selectedValue = this.value;
  applySort(selectedValue);
});
